import type { EntityConfig } from '../types'

export const cardSettlementTransactionEntity: EntityConfig = {
  name: 'card-settlement-transaction',
  displayName: 'Card Settlement',
  pluralName: 'Card Settlements',
  status: {
    field: 'status',
    options: [
      { value: 'settled', label: 'Settled', color: 'success' },
      { value: 'pending', label: 'Pending', color: 'warning' },
      { value: 'rejected', label: 'Rejected', color: 'error' },
      { value: 'reversed', label: 'Reversed', color: 'info' },
    ],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Settled', value: 'settled' },
      { label: 'Pending', value: 'pending' },
      { label: 'Rejected', value: 'rejected' },
      { label: 'Reversed', value: 'reversed' },
    ],
    mappings: {
      all: ['settled', 'pending', 'rejected', 'reversed'],
      settled: ['settled'],
      pending: ['pending'],
      rejected: ['rejected'],
      reversed: ['reversed'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    network: { field: 'network', type: 'select', label: 'Network' },
  },
  uiFilterFields: ['status', 'network'],
}
